module.exports = __webpack_public_path__ + "static/media/glass_show2.a73beccf.png";